import { ca } from '@cian/analytics';

export function trackViewAllClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click',
    label: 'GoToInfrastructure',
  });
}
